import * as React from 'react'
import firebase from 'firebase/app'
import 'firebase/database'
import './styles.scss'

type Props = {
  qId: number,
  title: string,
  question: string,
  children: string,
  subtitle: string,
  l: number,
  p: number,
  s: number,
  st: number,
  ch: number,
  suffix: string,
  source: string,
  articleId: number
}

const feedbackIcon = require('./img/icon-feedback.svg')
const feedbackIconInverted = require('./img/icon-feedback-inverted.svg')
const cursorIcon = require('./img/icon-cursor.svg')

export default class quizchart extends React.Component<Props> {
  constructor (props) {
    super(props)
    this.state = {
      quizPlayed: false,
      answerGiven: 'undefined',
      userIsCorrect: false,
      totalAnswers: -1,
      answerPerc: -1,
      answerPercTxt: 'undefined'
    }

    // Init Firebase
    let config = {
      apiKey: 'AIzaSyDbemUtN5bLJp2uSBjYDQ6LMkcH47zC6ik',
      authDomain: 'ta-talkback.firebaseapp.com',
      databaseURL: 'https://ta-talkback.firebaseio.com',
      storageBucket: 'ta-talkback.appspot.com'
    }
    if (!firebase.apps.length) {
      firebase.initializeApp(config)
    }

    let landTotal = parseFloat(props.l) + parseFloat(props.p)
    let stadtTotal = parseFloat(props.s) + parseFloat(props.st)

    if (landTotal > stadtTotal) {
      this.correctAnswer = 'land'
      // console.log('### ANSWER: land')
    } else {
      this.correctAnswer = 'stadt'
      // console.log('### ANSWER: stadt')
    }

    this.textLand = this.props.l.toString().replace('.', ',')
    this.textPeri = this.props.p.toString().replace('.', ',')
    this.textStaedtisch = this.props.s.toString().replace('.', ',')
    this.textStadt = this.props.st.toString().replace('.', ',')

    this.maxPercentage = Math.max(props.l, props.p, props.s, props.st, props.ch)

    this.barMaxHeight = 277
    this.barTopPoint = 29
    this.percTopPoint = 17.76

    this.landHeight = this.barMaxHeight / this.maxPercentage * props.l
    this.landTopPoint = this.barTopPoint + (this.barMaxHeight - this.landHeight)
    this.landPercY = this.percTopPoint + (this.barMaxHeight - this.landHeight)
    this.landPercTrans = 'translate(98.5 ' + this.landPercY + ')'

    this.periHeight = this.barMaxHeight / this.maxPercentage * props.p
    this.periTopPoint = this.barTopPoint + (this.barMaxHeight - this.periHeight)
    this.periPercY = this.percTopPoint + (this.barMaxHeight - this.periHeight)
    this.periPercTrans = 'translate(183.5 ' + this.periPercY + ')'

    this.staedtischHeight = this.barMaxHeight / this.maxPercentage * props.s
    this.staedtischTopPoint = this.barTopPoint + (this.barMaxHeight - this.staedtischHeight)
    this.staedtischPercY = this.percTopPoint + (this.barMaxHeight - this.staedtischHeight)
    this.staedtischPercTrans = 'translate(306.5 ' + this.staedtischPercY + ')'

    this.stadtHeight = this.barMaxHeight / this.maxPercentage * props.st
    this.stadtTopPoint = this.barTopPoint + (this.barMaxHeight - this.stadtHeight)
    this.stadtPercY = this.percTopPoint + (this.barMaxHeight - this.stadtHeight)
    this.stadtPercTrans = 'translate(393 ' + this.stadtPercY + ')'

    this.chTop = -38
    this.chY = this.chTop + (this.barMaxHeight / this.maxPercentage) * (this.maxPercentage - props.ch)
    this.chTrans = 'translate(0 ' + this.chY + ')'

    this.logAnswer = this.logAnswer.bind(this)
  }

  componentWillMount () {
    let storedAnswer = localStorage.getItem(this.props.qId)
    if (storedAnswer !== '') {
      this.setState({ answerGiven: 'voted' })
      this.setState({ quizPlayed: storedAnswer })
      this.getVotes(storedAnswer)
    }
  }

  logAnswer (e) {
    e.preventDefault()
    if (!this.state.quizPlayed) {
      let currentQuestion = e.currentTarget.getAttribute('data-question')
      let currentChoice = e.currentTarget.getAttribute('data-answer')
      this.addVote(currentChoice, currentQuestion)

      if (currentChoice === this.correctAnswer) {
        // console.log('USER IS CORRECT')
        this.setState({
          userIsCorrect: true,
          quizPlayed: true,
          answerGiven: currentChoice
        }, () => console.log(/* currentQuestion + ': ' + this.state.answerGiven */))
      } else {
        // console.log('USER IS NOT CORRECT')
        this.setState({
          userIsCorrect: false,
          quizPlayed: true,
          answerGiven: currentChoice
        }, () => console.log(/* currentQuestion + ': ' + this.state.answerGiven */))
      }
    }
  }

  /* increment in firebase */
  addVote (answer, questionText) {
    localStorage.setItem(this.props.qId, answer)
    let newVote = firebase.database().ref('stadt-land/stories/' + this.props.articleId + '/votes/' + this.props.qId + '/' + answer + /votes/)
    newVote.transaction((currentVotes) => {
      return currentVotes + 1
    }, (error, committed, snapshot) => {
      if (error) {
        // console.log('Transaction failed abnormally!', error)
      } else if (!committed) {
        // console.log('Transaction aborted')
      } else {
        /* transaction complete */
        this.getVotes(answer)
        // this.logClientIP(fbID, snapshot.val())

        /* update frontend */
        // this.getAllVotes()
      }
    })

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'Quiz: ' + questionText
    })
  }

  getVotes (answer) {
    /* firebase request */
    firebase.database().ref('stadt-land/stories/' + this.props.articleId + '/votes/' + this.props.qId).once('value').then(snapshot => {
      let landVotes = snapshot.child('land/votes').val()
      let stadtVotes = snapshot.child('stadt/votes').val()

      if (landVotes === null) {
        landVotes = 0
      }
      if (stadtVotes === null) {
        stadtVotes = 0
      }
      /* get quiz state from local storage */
      // extendedRow[8] = localStorage.getItem('vote-' + fbID)
      if (answer === 'land') {
        this.setState({ totalAnswers: Number(landVotes + stadtVotes) })
        this.setState({ answerPerc: Number((landVotes / (landVotes + stadtVotes) * 100).toFixed(1)) }, () => this.setState({ answerPercTxt: this.state.answerPerc.toString().replace('.', ',') }))
      } else if (answer === 'stadt') {
        this.setState({ totalAnswers: Number(landVotes + stadtVotes) })
        this.setState({ answerPerc: Number((stadtVotes / (landVotes + stadtVotes) * 100).toFixed(1)) }, () => this.setState({ answerPercTxt: this.state.answerPerc.toString().replace('.', ',') }))
      } else {
        this.setState({ totalAnswers: -1 })
        this.setState({ answerPerc: -1 }, () => this.setState({ answerPercTxt: 'undefined' }))
      }
      // console.log('##### ' + answer + ' votes: ' + this.state.answerPerc + '% of ' + this.state.totalAnswers)
    })
  }

  render () {
    let feedbackTextCorrect = <p className='user-result correct'><div className='icon-inline' style={{backgroundImage: `url(${feedbackIconInverted})`}} />Sie haben <strong>richtig</strong> getippt.</p>
    let feedbackTextIncorrect = <p className='user-result incorrect'><div className='icon-inline' style={{backgroundImage: `url(${feedbackIconInverted})`}} />Ihr Tipp war leider <strong>falsch</strong>.</p>
    let feedbackCrowdCorrect = <p className='crowd-result'>{this.state.answerPerc >= 0 ? <span><strong><span dangerouslySetInnerHTML={{__html: this.state.answerPercTxt}} />%</strong><span dangerouslySetInnerHTML={{__html: '  der ' + this.state.totalAnswers + ' Leserinnen und Leser tippten gleich wie Sie und lagen mit ihrer Einschätzung richtig.'}} /></span> : <div className='ui active centered inline loader tiny' />}</p>
    let feedbackCrowdIncorrect = <p className='crowd-result'>{this.state.answerPerc >= 0 ? <span><strong><span dangerouslySetInnerHTML={{__html: this.state.answerPercTxt}} />%</strong><span dangerouslySetInnerHTML={{__html: '  der ' + this.state.totalAnswers + ' Leserinnen und Leser tippten gleich wie Sie und lagen mit ihrer Einschätzung daneben.'}} /></span> : <div className='ui active centered inline loader tiny' />}</p>

    return (
      <div className={this.state.quizPlayed ? 'quiz-chart played' : 'quiz-chart'}>
        <h3>{this.state.quizPlayed ? this.props.title : this.props.question}</h3>
        <h5>{this.props.subtitle}</h5>

        <div className='quiz-wrapper'>
          <div className='chart-wrapper'>
            <div className='ui fluid image graph'>
              <svg id='Ebene_1' xmlns='http://www.w3.org/2000/svg' width='486' height='307' viewBox='0 0 486 307'><g id='ch'><path transform={this.chTrans} fill='#9E9E9E' d='M34 69.5v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6-.1v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6-.1v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6-.1v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6-.1v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6-.1v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6-.1v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6-.1v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6-.1v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6-.1v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6-.1v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h3v1h-3zm6 0v-1h2v1h-2z' /><g fill='#636363' transform={this.chTrans}><path d='M448.3 67.7c0-4.2 1.8-6.5 4.5-6.5 2.3 0 3.5 1.6 3.9 4l-1.3.2c-.4-1.9-1.1-2.9-2.6-2.9-1.9 0-3 1.9-3 5.2 0 3.4 1.1 5.3 3.1 5.3 1.5 0 2.3-1 2.7-3.1l1.3.2c-.5 2.4-1.7 4.1-4 4.1-2.9.1-4.6-2.1-4.6-6.5zM458.8 61.5h1.4v5.3h5.1v-5.3h1.4v12.6h-1.4v-6h-5.1v6h-1.4V61.5zM468.9 68.2h3.5v1.2h-3.5v-1.2zM483.1 67.8c0 4.2-1.9 6.5-4.5 6.5-.9 0-1.8-.3-2.5-.8l-.7 1.4-.9-.5.9-1.6c-.9-1.1-1.3-2.8-1.3-4.9 0-4.2 1.9-6.5 4.6-6.5.9 0 1.8.3 2.4.8l.8-1.4.9.5-.9 1.6c.7 1 1.2 2.7 1.2 4.9zm-2.7-4.5c-.5-.5-1.1-.8-1.8-.8-1.9 0-3.1 1.9-3.1 5.2 0 1.5.3 2.7.7 3.6l4.2-8zm-3.7 8.9c.5.5 1.1.8 1.9.8 1.9 0 3.1-1.9 3.1-5.3 0-1.5-.3-2.7-.7-3.6l-4.3 8.1z' /></g></g><rect id='stadt' x='349.5' y={this.stadtTopPoint} fill='#323232' width='76' height={this.stadtHeight} /><rect id='staedtisch' x='270.5' y={this.staedtischTopPoint} fill='#555' width='75' height={this.staedtischHeight} /><rect id='periurban' x='143.5' y={this.periTopPoint} fill='#466658' width='75' height={this.periHeight} /><rect id='land' x='63.5' y={this.landTopPoint} fill='#53AE71' width='75' height={this.landHeight} /><rect x='87.5' y='275' fill='none' width='74' height='30' /><rect x='296.5' y='275' fill='none' width='74' height='30' /><rect x='400' y='275' fill='none' width='74' height='30' /><rect x='88.5' fill='none' width='76' height='28' /><text id='txt-land' transform='translate(84.5 286.1)' fill='#FFF'>Land</text><text id='txt-periurban' transform='translate(150 286.1)' fill='#FFF'>Periurban</text><text id='txt-staedtisch' transform='translate(278.5 286.1)' fill='#FFF'>Städtisch</text><text id='txt-stadt' transform='translate(371 286.1)' fill='#FFF'>Stadt</text><path id='skyscraper_1_' d='M447.5 305.7v-9.9h-7v9.9H437v-36.2h14v32.7h1.2v-33.9h-2.4v-3.5h-11.7v3.5h-2.3v37.3m3.5-39.6h9.3v2.3h-9.3V266zm-1.1 7v4.7h4.7V273h-4.7zm1.1 1.2h2.3v2.3h-2.3v-2.3zm5.9 5.8v4.7h4.7V280h-4.7zm1.1 1.2h2.3v2.3h-2.3v-2.3zm-8.1 5.8v4.7h4.7V287h-4.7zm1.1 1.2h2.3v2.3h-2.3v-2.3zm2.4 8.7h1.8v8.8h-1.8v-8.8zm2.9 0h1.8v8.8h-1.8v-8.8z' /><text id='perc-land' transform={this.landPercTrans} fill='#53AE71' textAnchor='middle'>{this.textLand}{this.props.suffix}</text><rect x='183.5' fill='none' width='76' height='28' /><text id='perc-periurban' transform={this.periPercTrans} fill='#466658' textAnchor='middle'>{this.textPeri}{this.props.suffix}</text><rect x='295.5' fill='none' width='76' height='28' /><text id='perc-staedtisch' transform={this.staedtischPercTrans} fill='#555' textAnchor='middle'>{this.textStaedtisch}{this.props.suffix}</text><rect x='402' fill='none' width='76' height='28' /><text id='perc-stadt' transform={this.stadtPercTrans} fill='#323232' textAnchor='middle'>{this.textStadt}{this.props.suffix}</text><g fill='#57AE73'><path d='M52.6 275.9l-.2-.1v-.3c.1-.4.1-.8.1-1.1 0-5-4.1-9.2-9.2-9.2s-9.2 4.1-9.2 9.2c0 .4 0 .7.1 1.1v.3l-.2.1c-2.9 1.6-4.7 4.7-4.7 8 0 5 4.1 9.2 9.2 9.2 1.6 0 3.2-.4 4.6-1.3h.4V290c-.1 0-.5.1-.6.1-1.3.9-2.8 1.4-4.3 1.4-4.2 0-7.6-3.4-7.6-7.6 0-3 1.8-5.7 4.6-7 .4-.1.5-.5.4-.9-.1-.6-.2-1.1-.2-1.7 0-4.1 3.4-7.6 7.6-7.6s7.6 3.4 7.6 7.6c0 .6-.1 1.1-.2 1.7-.1.4.1.7.4.9 2.7 1.2 4.6 4 4.6 7 0 3.7-2.7 6.8-6.2 7.5v1.5c4.3-.7 7.7-4.5 7.7-9-.1-3.3-1.9-6.4-4.7-8z' /><path d='M43 305.6V293c0-.4-.3-.7-.7-.7-.4 0-.7.3-.7.7v12.7c0 .4.3.7.7.7s.7-.4.7-.8zm2.3 0V293c0-.4-.3-.7-.7-.7-.4 0-.7.3-.7.7v12.7c0 .4.3.7.7.7.3-.1.7-.4.7-.8z' /></g><line fill='none' stroke='#9E9E9E' x1='32.5' y1='306' x2='231.2' y2='306' /><line fill='none' stroke='#9E9E9E' x1='253.5' y1='306' x2='452.2' y2='306' /></svg>
            </div>
            <div className='source'>Quelle: {this.props.source}</div>
          </div>

          <div className='decision-maker'>
            <a data-question={this.props.title} data-answer='land' onClick={this.logAnswer}>
              <div className={this.state.answerGiven === 'land' ? 'answer countryside selected' : this.state.answerGiven === 'stadt' ? 'answer countryside rejected' : 'answer countryside'}>
                <div className='option'>
                  <div className='icon-wrapper'>
                    <svg id='Ebene_1' xmlns='http://www.w3.org/2000/svg' width='195' height='300' viewBox='0 0 195 300'><path className='tree' d='M162 74.4l-1.7-1 .2-2c.3-2.6.5-5.2.5-7.6C161 28.6 132.4 0 97.2 0S33.4 28.6 33.4 63.8c0 2.5.2 5.1.5 7.6l.2 2-1.7 1C12.4 85.7 0 107 0 129.9c0 35.2 28.6 63.8 63.8 63.8 11.2 0 22.2-3 31.9-8.6l2.7-.2v-12.2c-.7.1-3.6.3-4.2.7-8.9 6.3-19.4 9.6-30.3 9.6-29.3 0-53.1-23.8-53.1-53.1 0-21 12.4-40 31.6-48.6 2.3-1 3.6-3.6 3.1-6.1-.9-3.9-1.3-7.7-1.3-11.5 0-29.3 23.8-53.1 53.1-53.1s53.1 23.8 53.1 53.1c0 3.8-.4 7.7-1.3 11.5-.5 2.5.7 5 3.1 6.1 19.2 8.5 31.7 27.6 31.7 48.6 0 25.8-18.5 47.3-42.9 52.1v10.9c30.3-4.9 53.6-31.3 53.6-63-.3-22.9-12.7-44.2-32.6-55.5z' fill='#57ae73' /><path className='tree' d='M95.9 281.2v-88.1c0-2.6-2.1-4.8-4.8-4.8-2.6 0-4.8 2.1-4.8 4.8v88.1c0 2.6 2.1 4.8 4.8 4.8 2.7 0 4.8-2.1 4.8-4.8zm15.5 0v-88.1c0-2.6-2.1-4.8-4.8-4.8-2.6 0-4.8 2.1-4.8 4.8v88.1c0 2.6 2.1 4.8 4.8 4.8 2.7 0 4.8-2.1 4.8-4.8z' fill='#57ae73' /><path className='tree' d='M67.7 283.9v8.3h70.9v-8.3' fill='#57ae73' /></svg>
                    <div className='click-title'>Land</div>
                    <div className={this.state.userIsCorrect ? 'feedback-icon correct' : 'feedback-icon incorrect'} style={{backgroundImage: `url(${feedbackIcon})`}} />
                  </div>
                </div>
              </div>
            </a>

            <a data-question={this.props.title} data-answer='stadt' onClick={this.logAnswer}>
              <div className={this.state.answerGiven === 'stadt' ? 'answer city selected' : this.state.answerGiven === 'land' ? 'answer city rejected' : 'answer city'}>
                <div className='option'>
                  <div className='icon-wrapper'>
                    <svg id='Ebene_1' xmlns='http://www.w3.org/2000/svg' width='195' height='300' viewBox='0 0 195 300'><path id='skyscraper' d='M55.5 0v25H38.8v265.8H14v8.3h166.1v-8.3H122v-70.6H72.1v70.6H47.2V33.2h99.7v232.6h8.3V24.9h-16.7V0h-83zm8.3 8.3h66.4v16.6H63.8V8.3zm-8.3 49.8v33.3h33.3V58.1H55.5zm8.3 8.3h16.6V83H63.8V66.4zm41.5 41.6v33.2h33.3V108H105.3zm8.3 8.3h16.6v16.6h-16.6v-16.6zm-58.1 41.5v33.3h33.3v-33.3H55.5zm8.3 8.3h16.6v16.6H63.8v-16.6zm16.6 62.3h12.5v62.3H80.4v-62.3zm20.8 0h12.5v62.3h-12.5v-62.3z' /></svg>
                    <div className='click-title'>Stadt</div>
                    <div className={this.state.userIsCorrect ? 'feedback-icon correct' : 'feedback-icon incorrect'} style={{backgroundImage: `url(${feedbackIcon})`}} />
                  </div>
                </div>
              </div>
            </a>

            <div className='separator' />
            <div className='or'>
              <div className='back-box'>oder</div>
            </div>
            <div className='hintcursor' style={{backgroundImage: `url(${cursorIcon})`}} />
          </div>

        </div>

        <div className='feedback'>
          {this.state.userIsCorrect ? feedbackTextCorrect : feedbackTextIncorrect}
          {this.state.userIsCorrect ? feedbackCrowdCorrect : feedbackCrowdIncorrect}
        </div>

        <div className='explainer'>
          {this.props.children}
        </div>

      </div>
    )
  }
}
